import arrayReduce from './arrayReduce';

export default function applyMediaRulesInOrder(order) {
  return arrayReduce(order, function (mediaRules, query) {
    mediaRules[query] = '';
    return mediaRules;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/node_modules/fela-utils/es/applyMediaRulesInOrder.js
// module id = 756
// module chunks = 0